import React from "react";
import { Icon } from "@qgiv/core-react";
import cx from "classnames";
import "./EmployerMatchingHeader.scss";

/**
 * @param {object} props
 * @param {string} props.sectionHeading
 * @param {string} props.description
 * @param {string} props.iconGlyph
 * @param {boolean} props.matchConfirmed
 * @param {Function} props.handleCancelButton
 * @param {boolean} props.shouldColorIcon
 * @returns {React.JSX.Element}
 */
const EmployerMatchingHeader = ({
    sectionHeading,
    description,
    iconGlyph,
    matchConfirmed,
    handleCancelButton,
    shouldColorIcon,
}) => (
    <div className="qg-vendor-gift-matching__header gift-matching__header">
        <Icon
            ariaHidden
            className={cx(
                "-type--3xlarge",
                "gift-matching__header--icon",
                "-vertical-align--middle",
                shouldColorIcon && "gift-matching__header--icon--focused",
            )}
            glyph={iconGlyph}
            type="FontAwesome"
        />
        <h2 className="header__title">{sectionHeading}</h2>
        {description && (
            <p
                className={cx(
                    "gift-matching__header--subtitle",
                    matchConfirmed &&
                        "gift-matching__header--subtitle-centered",
                )}
            >
                {description}
            </p>
        )}
        {matchConfirmed && (
            <button
                type="button"
                className="-cursor--pointer cancel-search -margin-top--5"
                onClick={(e) => handleCancelButton(e)}
                onKeyDown={(e) => handleCancelButton(e)}
            >
                <span className="link">
                    <strong>Select a different company</strong>
                </span>
            </button>
        )}
    </div>
);

export default EmployerMatchingHeader;
